// Imports
import React from "react";
import RecCardHero from "../../RecCardHero/jsx/index.jsx";
import RecCard from "../../RecCard/jsx/index.jsx";
import RecSwiper from "../../RecSwiper/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import RecBars from "../../RecBars/jsx/index.jsx";

const RecTiles = () => {
  const { articles } = useQuiz();
  const first = articles.length ? [...articles].shift() : null;
  const filtered = articles.length
    ? articles.filter((a) => a.id !== first.id)
    : articles;
  return (
    <>
      <div className="rec-tiles">
        <div className="rec-tiles__main">
          <RecBars />
          {first && <RecCardHero {...first} />}
          {/* <RecSwiper /> */}
        </div>
        <div className="rec-tiles__supp">
          {filtered.map((a) => (
            <RecCard key={a?.id} {...a} />
          ))}
        </div>
      </div>
    </>
  );
};

export default RecTiles;
